import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import toast from 'react-hot-toast';
import WestfalenLogo from './WestfalenLogo';
import { apiService } from '@/services/api';

const LoginForm: React.FC = () => {
  const [companyName, setCompanyName] = useState<string>('Westfalen AG');
  const [logoPath, setLogoPath] = useState<string | null>(null);
  const [logoLoading, setLogoLoading] = useState(true);

  useEffect(() => {
    fetchCompanyData();
  }, []);

  const fetchCompanyData = async () => {
    try {
      console.log('LoginForm: Fetching company data...');
      
      // Verwende die öffentlichen Endpunkte
      const [logoResponse, companyNameResponse] = await Promise.all([
        apiService.get<{ success: boolean; logo: string }>('/system/public/company_logo'),
        apiService.get<{ success: boolean; companyName: string }>('/system/public/company_name')
      ]);
      
      console.log('LoginForm: Logo response:', logoResponse);
      console.log('LoginForm: Company name response:', companyNameResponse);
      
      if (logoResponse?.logo && logoResponse.logo.trim() !== '') {
        console.log('LoginForm: Setting logo path');
        setLogoPath(logoResponse.logo);
      } else {
        console.log('LoginForm: No logo found');
        setLogoPath(null);
      }

      if (companyNameResponse?.companyName && companyNameResponse.companyName.trim() !== '') {
        console.log('LoginForm: Setting company name:', companyNameResponse.companyName);
        setCompanyName(companyNameResponse.companyName);
      } else {
        console.log('LoginForm: Using default company name');
        // Fallback bleibt bestehen
      }
    } catch (error) {
      console.error('LoginForm: Error fetching company data:', error);
      // Fallbacks bleiben bestehen
    } finally {
      setLogoLoading(false);
    }
  };

  const handleAzureLogin = async () => {
    try {
      // Verwende die öffentliche URL für Azure Auth (muss vom Browser erreichbar sein)
      const publicBackendUrl = (import.meta as any).env?.VITE_PUBLIC_API_URL;
      if (!publicBackendUrl) {
        throw new Error('VITE_PUBLIC_API_URL ist nicht konfiguriert');
      }
      const authUrl = `${publicBackendUrl}/api/auth/azure`;
      
      console.log('Redirecting to:', authUrl);
      
      // Verwende window.location.replace für besseren Redirect
      window.location.replace(authUrl);
    } catch (error: any) {
      console.error('Azure login error:', error);
      toast.error('Fehler beim Azure AD Login');
    }
  };

  return (
    <div className="w-full max-w-md space-y-8 card-westfalen p-8">
             <div className="text-center">
         <div className="flex justify-center mb-6">
           {logoLoading ? (
             <div className="h-16 w-16 animate-pulse bg-gray-200 rounded"></div>
           ) : logoPath ? (
             <div className="flex flex-col items-center">
               <img
                 src={logoPath}
                 alt="Company Logo"
                 className="h-16 w-auto object-contain"
               />
             </div>
           ) : (
             <WestfalenLogo size="lg" />
           )}
         </div>
         <h2 className="text-3xl font-bold tracking-tight text-westfalen-primary mb-2">
           {companyName} <br />Inventar Management
         </h2>
        <p className="text-sm text-westfalen-secondary">
          Melden Sie sich mit Ihrem Azure AD Konto an
        </p>
      </div>

      <div className="space-y-6">
        <Button
          onClick={handleAzureLogin}
          className="w-full h-12 text-lg font-semibold btn-westfalen"
          size="lg"
        >
          <svg 
            className="mr-3 h-6 w-6" 
            viewBox="0 0 24 24" 
            fill="currentColor"
          >
            <path d="M11.4 24H0V12.6h11.4V24zM24 24H12.6V12.6H24V24zM11.4 11.4H0V0h11.4v11.4zM24 11.4H12.6V0H24v11.4z"/>
          </svg>
          Entra Auth
        </Button>
      </div>
    </div>
  );
};

export default LoginForm;
